<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <api_general_tab :location="location"></api_general_tab>
        </template>


    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import api_general_tab from "./tabs/api_general_tab";


export default {
    name: "api_location_modal",
    components : {
        api_general_tab,
        base_location_modal,
    },
    data () {
        return {
            tabs_add : [
              /*  {
                    index : "pwa_location_image",
                    title : this.__t('PWA_IMAGE'),
                },*/

            ]
        }
    },
}
</script>

<style scoped>

</style>
